/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';

// components
import Image from '../ZUILib/Image';
import ModalPopover from '../ZUILib/ModalPopover';
import Link from '../ZUILib/Link';
import StepBar from '../ZUILib/StepBar';
import Notifications from '../../components/Notifications';
import ConfirmationModal from '../ZUILib/ConfirmationModal';
import commonUtil from '../../utils/commonUtil';
import serverClientUtil from '../../utils/serverClientUtil';
import { eventCategory, constChannel } from '../../utils/clientConstant';

// Actions
import * as notificationsActions from '../../components/Notifications/actions';
import * as eventDetails from '../../components/EventDetails/actions';
import * as createEventAction from '../../pages/createEvent/actions';
import * as createAccountActions from '../../pages/Accounts/createAccount/actions';
import * as targetterContentActions from '../../pages/BrowseAndNavigate/GiftRegistryhome/actions';
import { loadGiftRegistryCelebrated } from '../../pages/createEvent/components/GiftRegistryCelebrated/actions';
import { updateGiftListHeader } from '../../components/globleObject/actions';
import AppEvents from './../../pages/App/AppEvents';
import { validateEventDate } from './actions';
import { createTag } from '../../utils/googleTagManagerUtils';
import _ from 'lodash';

// Constants
const applicationRoutes = commonUtil.getApplicationRoutes();
const channel = commonUtil.getChannel();
const {
  GR_HEADER_TYPE,
  grHeaderConfig,
  grHeaderMenuHighlightConfig,
} = require('./../../utils/config/grHeaderConfig');

const mesa_de_regalos_logo = commonUtil.getImageMeta().mesaDeRegalosLogo;

@connect(
  (store) => ({
    content: store.targetterContent.data,
    notifications: store.notifications.data,
    countDataNotifications: store.notifications.countData,
    user: store.user.data,
    eventDetails: store.eventDetail,
    lables: store.labels.data,
    globalObject: store.globleObject,
  }),
  {
    ...notificationsActions,
    ...createEventAction,
    ...eventDetails,
    ...createAccountActions,
    ...targetterContentActions,
    updateGiftListHeader,
  },
)
class GRHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventId:
        this.props.params &&
        (this.props.params.eventID || this.props.params.eventId)
          ? this.props.params.eventID || this.props.params.eventId
          : null,
    };
    this.profileId =
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
        ? this.props.user.result.profileId
        : '';
    this.renderComponent = this.renderComponent.bind(this);
    this.toggleHamburgerMenu = this.toggleHamburgerMenu.bind(this);
    this.updateHeaderType();
    this.cancelFunc = this.cancelFunc.bind(this);
    this.isEventManagementRoute = false;
    this.stepBarInfo = {};
    this.eventToken = '';
    this.createEventLogoClick = undefined;
    this.addClass = false;
    this.isClicked = 'false';
    this.renderHeaderWithLogoAndMenuForHomePage =
      this.renderHeaderWithLogoAndMenuForHomePage.bind(this);
    // this.getNotificationFlag = true;
    this.lastPath = '';
    this.quitMessage =
      this.props.lables && this.props.lables.createEventStep1
        ? commonUtil.getLabel(
            this.props.lables.createEventStep1,
            'createEventStep1.quitCreatingEvent.message',
          )
        : '';
    this.externalClickHandlerForWapBackButton = null;
    // event management variables
    this.eventManagementMenus = {};
    this.eventManagementMenuHTML = [];
    this.eventManagementRoutes = [];
    this.getEventToolsData = null;
    this.wapTools = null;
  }
  UNSAFE_componentWillMount() {
    // AppEvents.hookEvent(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED_GR, this.hookWapBackClickHandler);
  }
  componentDidMount() {
    this.addFunctionToHomeHemburgerURL();
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.CREATE_EVENT_STEP_BAR,
      this.renderStepBarHeader,
    );
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.CREATE_EVENT_LOGO_CLICK,
      this.registerCreateEventLogoClick,
    );
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.EVENT_MANEGEMENT_MENU_WAP,
      this.renderEventManagementMenuForWap,
    );
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN,
      this.getEventToken,
    );
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS,
      this.outlookCallback,
    );
    AppEvents.hookEvent(
      AppEvents.EVENT_REGISTER.YAHOO_CONTACTS,
      this.outlookCallback,
    );
  }

  componentWillUnmount() {
    // AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED_GR);
    AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.CREATE_EVENT_STEP_BAR);
    AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.EVENT_MANEGEMENT_MENU_WAP);
    AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.GET_EVENT_TOKEN);
    AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.OUTLOOK_CONTACTS);
    AppEvents.unhookEvent(AppEvents.EVENT_REGISTER.YAHOO_CONTACTS);
  }
  registerCreateEventLogoClick = (data) => {
    this.createEventLogoClick = data;
  };
  hookWapBackClickHandler = (func) => {
    if (func && typeof func === 'function') {
      this.externalClickHandlerForWapBackButton = func;
    }
  };
  wapReturnClickHandler = (e) => {
    if (
      this.externalClickHandlerForWapBackButton &&
      typeof this.externalClickHandlerForWapBackButton === 'function'
    ) {
      this.externalClickHandlerForWapBackButton(e);
    }
  };
  outlookCallback = (outlookContactsData) => {
    // eslint-disable-next-line no-console
    console.log('outlookContactsData :: ', outlookContactsData); // console required
  };
  updateHeaderType() {
    this.routePath =
      this.props.routes && this.props.routes.length > 3
        ? this.props.routes[this.props.routes.length - 1].path
        : this.props.routes[this.props.routes.length - 2].path;
    this.headerType = grHeaderConfig[this.routePath][channel];
  }
  yahooCallBack = (contacts) => {
    // eslint-disable-next-line no-console
    console.log('Response from Yahoo :: ', JSON.stringify(contacts)); // console required
  };

  createTagOnCreateGiftTableClick = () => {
    const selectedEventId = this.state.eventId;
    const userEvents = _.get(this.props, 'eventDetails.data.eventList');
    if (_.isNil(selectedEventId) || !_.isArray(userEvents)) return;

    const selectedEvent = userEvents.find((e) => e.eventId === selectedEventId);
    if (_.isNil(selectedEvent)) return;

    const selectedEventName = _.get(
      selectedEvent,
      'eventName',
      'undefined table name',
    );
    createTag({
      event: 'mesa_regalos',
      phase: 'Banner Mesa de regalos con eventos',
      selection: 'Crear mesa de regalos',
      nombre_mesa: selectedEventName,
      numero_mesa: selectedEventId,
      seccion: 'Mesa de Regalos',
    });
  };

  checkEventEligibleToCreate = () => {
    if (this.props && this.props.user && this.props.user.result.emailId) {
      const emailId = this.props.user && this.props.user.result.emailId;
      loadGiftRegistryCelebrated(emailId).then((response) => {
        if (response.body.status.status === 'success') {
          this.createTagOnCreateGiftTableClick();
          browserHistory.push(
            commonUtil.getRouteByParameter(applicationRoutes.mesaType),
          );
        } else {
          browserHistory.push(
            commonUtil.getRouteByParameter(applicationRoutes.maxEvents),
          );
        }
      });
    }
  };
  handleOutsideClick = (e) => {
    if (
      !this.notificationContainer.contains(e.target) &&
      this.notificationContainer.style.display === 'block'
    ) {
      // this.openNotificationBar();
      this.notificationContainer.style.display = 'none';
    }
  };
  openNotification = (id) => {
    const notificationContainer = document.querySelector(id);
    if (notificationContainer.style.display === 'block') {
      this.isClicked = 'true';
    } else {
      this.isClicked = 'false';
    }
    this.toggleHamburgerMenu(id);
    this.notiModal.handleShow();
    const { countNotification } = this.props;
    countNotification(this.state.eventId, this.profileId, this.isClicked);
  };
  openNotificationBar = () => {
    if (
      this.notificationContainer &&
      this.notificationContainer.style &&
      this.notificationContainer.style.display === 'none'
    ) {
      this.isClicked = 'true';
      this.notificationContainer.style.display = 'block';
      document.addEventListener('click', this.handleOutsideClick, true);
    } else if (this.notificationContainer && this.notificationContainer.style) {
      this.isClicked = 'false';
      this.notificationContainer.style.display = 'none';
      document.removeEventListener('click', this.handleOutsideClick, true);
    }
    const { countNotification } = this.props;
    countNotification(this.state.eventId, this.profileId, this.isClicked);
  };
  cancelFunc(e) {
    e.preventDefault();
    const { clearEventData } = this.props; // eslint-disable-line no-shadow
    clearEventData();
  }
  dispatchThenRoute = (val) => {
    const eventDetailsData =
      this.props.eventDetails &&
      this.props.eventDetails.data &&
      this.props.eventDetails.data.eventList;
    if (
      val === 'createEvent' &&
      eventDetailsData &&
      eventDetailsData.length === 1
    ) {
      this.props.router.setRouteLeaveHook(this.props.route, '');
      this.modal.open(
        commonUtil.getRouteByParameter(applicationRoutes.giftList, {
          eventID: eventDetailsData[0].eventId,
        }),
      );
    } else if (
      val === 'createEvent' &&
      eventDetailsData &&
      eventDetailsData.length > 1
    ) {
      this.props.router.setRouteLeaveHook(this.props.route, '');
      this.modal.open(applicationRoutes.home);
    } else if (val === 'createEvent') {
      this.props.router.setRouteLeaveHook(this.props.route, '');
      this.modal.open(applicationRoutes.home);
    } else if (eventDetailsData && eventDetailsData.length === 1) {
      browserHistory.push(
        commonUtil.getRouteByParameter(applicationRoutes.giftList, {
          eventID: eventDetailsData[0].eventId,
        }),
      );
    } else if (eventDetailsData && eventDetailsData.length > 1) {
      browserHistory.push(applicationRoutes.home);
    } else if (window) {
      window.location.href = '/';
    }
  };
  renderStepBarHeader = (stepBarData) => {
    if (stepBarData && !commonUtil.isEmpty(stepBarData)) {
      this.stepBarInfo = stepBarData;
    }
    this.setState({ updated: true });
  };
  addClassToHeader = () => {
    const routeData = [
      applicationRoutes.partialTransference, // Account Transference and clouser
      applicationRoutes.partialConfirmation,
      applicationRoutes.closureTransference,
      applicationRoutes.closureConfirmation,
    ];
    const currentRoute =
      this.props.Router &&
      this.props.Router.location &&
      this.props.Router.location.pathname
        ? this.props.Router.location.pathname
        : '';
    const routeProps = this.props.params ? this.props.params : '';
    if (routeData && routeData.length > 0) {
      routeData.map((info) => {
        const exactRoute = commonUtil.getRouteByParameter(info, routeProps);
        if (exactRoute && exactRoute === currentRoute) {
          return (this.addClass = true);
        }
        return false;
      });
    }
  };
  renderHeaderWithLogo = () => {
    this.addClassToHeader();

    return (
      <React.Fragment>
        {channel === 'wap' ? (
          <div className='container'>
            <div className='row'>
              <div className='giftRegistryHeader'>
                <div className='wrapHeader'>
                  <div className='logoContainer'>
                    <div className='logo hover-icon'>
                      <img
                        src={mesa_de_regalos_logo}
                        onClick={this.dispatchThenRoute}
                        alt='Mesa de Regalos'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ConfirmationModal
                ref={(modal) => (this.modal = modal)}
                message={this.quitMessage}
              />
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className='giftRegistryHeader'>
              <div
                className={
                  this.addClass
                    ? 'mesaregaloslogo-partial-closure wrapHeader'
                    : 'wrapHeader'
                }
              >
                <div className='logoContainer'>
                  <div className='logo hover-icon'>
                    <img
                      src={mesa_de_regalos_logo}
                      onClick={this.dispatchThenRoute}
                      alt='Mesa de Regalos'
                    />
                  </div>
                </div>
              </div>
            </div>
            <ConfirmationModal
              ref={(modal) => (this.modal = modal)}
              message={this.quitMessage}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };
  returnClickHandler = (e) => {
    const currentRoute =
      this.props.Router &&
      this.props.Router.location &&
      this.props.Router.location.pathname
        ? this.props.Router.location.pathname
        : '';
    if (this.props?.globalObject?.giftListHeader != 'Mesa de regalos') {
      this.props.updateGiftListHeader('Mesa de regalos');
      browserHistory.push(currentRoute);
    } else {
      browserHistory.push('/');
    }
  };
  renderHeaderWithLogoAndAdditionalData = () => (
    // Hader with only Logo.
    <React.Fragment>
      {channel === 'wap' ? (
        <div className='container'>
          <div className='row'>
            <div className='giftRegistryHeader'>
              <div className='wrapHeader'>
                <div className='logoContainer'>
                  <div className='logo hover-icon'>
                    <img
                      src={mesa_de_regalos_logo}
                      onClick={this.dispatchThenRoute}
                      alt='Mesa de Regalos'
                    />
                  </div>
                  <span>Additional data here...</span>
                </div>
              </div>
            </div>
            <ConfirmationModal
              ref={(modal) => (this.modal = modal)}
              message={this.quitMessage}
            />
          </div>
        </div>
      ) : (
        <div className='row'>
          <div className='giftRegistryHeader'>
            <div className='wrapHeader'>
              <div className='logoContainer'>
                <div className='logo hover-icon'>
                  <img
                    src={mesa_de_regalos_logo}
                    onClick={this.dispatchThenRoute}
                    alt='Mesa de Regalos'
                  />
                </div>
                <span>Additional data here...</span>
              </div>
            </div>
          </div>
          <ConfirmationModal
            ref={(modal) => (this.modal = modal)}
            message={this.quitMessage}
          />
        </div>
      )}
    </React.Fragment>
  );
  renderHeaderWithLogoAndStepBar = () => {
    // Header with stepBar.
    let info = {};
    if (!commonUtil.isEmpty(this.stepBarInfo)) {
      info = {
        currentStep: this.stepBarInfo.currentStep,
        total: this.stepBarInfo.total,
      };
    }
    return (
      <div className='row stepbarRow stepbarRow-header'>
        <div className='col-xs-12 stepbarContainer'>
          <div className='giftRegistryHeader gr-reg-header'>
            <div className='wrapHeader wrap-header-overflow-overide'>
              <StepBar info={info} />
            </div>
            <ConfirmationModal
              ref={(modal) => (this.modal = modal)}
              cancelClick={this.cancelFunc}
              message={this.quitMessage}
              removeRouteLeaveHook={this.createEventLogoClick}
            />
          </div>
        </div>
      </div>
    );
  };

  getMenuRoutes = () => {
    const routeProps = Object.assign({}, this.props.params);
    // const isChildRoute = false;
    const eventManagmentRoutProps = routeProps;
    if (!eventManagmentRoutProps.pageName) {
      eventManagmentRoutProps.pageName = 'DatosDeMiEvento';
    }

    this.eventToken =
      this.props.eventDetails &&
      this.props.eventDetails.tokenForEvent &&
      this.props.eventDetails.tokenForEvent.eventTokeninfo &&
      this.props.eventDetails.tokenForEvent.eventTokeninfo.tokenId
        ? this.props.eventDetails.tokenForEvent.eventTokeninfo.tokenId
        : null;

    const validateDateForTools = validateEventDate(
      this.props.eventDetails,
      this.state.eventId,
    );

    let toolsMenu = {};
    if (this.getEventToolsData && this.getEventToolsData.toolsInfo) {
      toolsMenu =
        validateDateForTools &&
        !this.getEventToolsData.useGuestList &&
        !this.getEventToolsData.useTableOrganizer
          ? {
              route:
                this.getEventToolsData.toolsInfo.toolsNotInUse[2].toolName ===
                'VirtualInvitation'
                  ? commonUtil.routeTo(applicationRoutes.invitationTemplate, {
                      eventID: this.state.eventId,
                    })
                  : commonUtil.routeTo(applicationRoutes.myInvitation, {
                      eventID: this.state.eventId,
                    }),
              displayName: 'INVITACIÓN VIRTUAL',
            }
          : {
              route: commonUtil.getRouteByParameter(
                applicationRoutes.toolsForMyEvent,
                routeProps,
              ),
              displayName: 'HERRAMIENTAS PARA MI EVENTO',
            };
    }

    const routesInfo = [
      {
        route: commonUtil.getRouteByParameter(
          applicationRoutes.giftList,
          eventManagmentRoutProps,
        ),
        displayName: 'ADMINISTRACIÓN DE REGALOS ',
      },
      {
        href:
          this.eventToken && this.eventToken !== null
            ? serverClientUtil.getEventWebSiteURL() +
              '?eventId=' +
              this.state.eventId +
              '&token=' +
              this.eventToken
            : '',
        cssClass:
          this.eventToken && this.eventToken !== null ? '' : 'activeURL',
        displayName: 'PÁGINA WEB DE MI EVENTO',
        isNotSamePage: true,
      },
      toolsMenu,
      {
        route: commonUtil.getRouteByParameter(
          applicationRoutes.searchEvent,
          routeProps,
        ),
        displayName: 'BUSCAR UNA MESA',
      },
      {
        displayName: 'CREAR NUEVA MESA',
        onClickHandler: this.checkEventEligibleToCreate,
      },
    ];

    if (!validateDateForTools) {
      routesInfo.splice(2, 1);
    }

    const links = [];
    routesInfo.forEach((info) => {
      const currentPath =
        this.props && this.props.location && this.props.location.pathname
          ? this.props.location.pathname
          : null;
      const data = info;

      // let route = '';
      if (
        currentPath &&
        data.displayName &&
        grHeaderMenuHighlightConfig &&
        grHeaderMenuHighlightConfig.length
      ) {
        grHeaderMenuHighlightConfig.forEach((config) => {
          if (config.link === data.displayName && config.paths.length) {
            config.paths.forEach((routeLink) => {
              const tempRoute = commonUtil.getRouteByParameter(
                routeLink,
                routeProps,
              );
              if (data.href === currentPath || currentPath === tempRoute) {
                data.cssClass = 'activeOption';
              }
            });
          }
        });
      }
      if (data && data.route) {
        links.push(
          <li>
            <Link rrLink={data} classname={data.cssClass} />
          </li>,
        );
      } else {
        links.push(
          <li>
            <Link linkJSON={data}>{data.displayName}</Link>
          </li>,
        );
      }
    });
    return links;
  };
  markAllRead = () => {
    const notifications = this.props.notifications;
    if (
      notifications &&
      notifications.notifications &&
      notifications.notifications.length > 0
    ) {
      const { updateNotificationsDetail, loadNotificationsDetail } = this.props;
      notifications.notifications.map((data) => {
        if (data.isRead === 'false' && data.notificationId && this.profileId) {
          updateNotificationsDetail(data.notificationId, this.profileId);
        }
        return null;
      });
      loadNotificationsDetail(this.state.eventId, this.profileId);
    }
  };
  renderHeaderWithLogoAndMenuForWeb = () => {
    this.profileId =
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
        ? this.props.user.result.profileId
        : '';
    this.state.eventId =
      this.props.params &&
      (this.props.params.eventID || this.props.params.eventId)
        ? this.props.params.eventID || this.props.params.eventId
        : '';
    const currentPage =
      this.props.Router &&
      this.props.Router.location &&
      this.props.Router.location.pathname
        ? this.props.Router.location.pathname
        : '';
    if (
      this.profileId &&
      this.state.eventId &&
      this.headerType &&
      this.headerType === GR_HEADER_TYPE.LOGO_MENU &&
      currentPage &&
      currentPage !== this.lastPath
    ) {
      this.lastPath = currentPage;
      // this.getNotificationFlag = false;
      const { loadNotificationsDetail } = this.props;
      loadNotificationsDetail(this.state.eventId, this.profileId);
      const { countNotification } = this.props;
      countNotification(this.state.eventId, this.profileId, this.isClicked);
    }
    const linkJSON1 = {
      text: 'Link Text',
      onClickHandler: this.dispatchThenRoute,
    };
    const _imgsrc = [
      {
        srcSet: mesa_de_regalos_logo,
      },
    ];
    const imageAttr = {
      id: 'img1',
      alt: 'Mesa de Regalos',
      src: mesa_de_regalos_logo,
      className: 'mainLogo',
    };

    let count = 0;
    if (this.props.countDataNotifications) {
      count = this.props.countDataNotifications.notificationCount || 0;
      // } else if (this.props.countDataNotifications && this.props.countDataNotifications.notificationCount) {
      //   count = this.props.countDataNotifications.notificationCount;
    }

    if (this.state.eventId) {
      // this.props.fetchEventManagementTools(this.state.eventId).then((res) => {
      //   if (res) {
      //     this.getEventToolsData = res;
      //   }
      // });
    }

    return (
      <div className='adminContainer admincontainer_line'>
        <div className='giftMenu'>
          <Link linkJSON={linkJSON1}>
            <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
          </Link>
          <ul>{this.getMenuRoutes()}</ul>
          <div className='giftNotifications hover-icon'>
            <a
              id='iconNotifications'
              onClick={this.openNotificationBar}
              onDoubleClick={this.markAllRead}
            >
              {count > 0 ? (
                <span className='notificationCount'>
                  <font>{count}</font>
                </span>
              ) : null}
              <img
                className='notificationLogo'
                src={
                  commonUtil.getAssetURL() +
                  '/images/admin/notificationIcon.png'
                }
                alt='Notification'
              />
            </a>
          </div>
        </div>
        <div
          ref={(notificationContainer) =>
            (this.notificationContainer = notificationContainer)
          }
          className='contentMenuNotifications'
          id='notificacionesMenu'
          style={{ display: 'none' }}
        >
          <Notifications
            notifications={this.props.notifications || null}
            eventId={this.state.eventId}
            profileId={this.profileId}
            openNotificationBar={this.openNotificationBar}
          />
        </div>
        <ConfirmationModal
          ref={(modal) => (this.modal = modal)}
          message={this.quitMessage}
        />
      </div>
    );
  };

  renderHeaderWithLogoAndMenuForWap = () => {
    // let count = 0;

    this.profileId =
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.profileId
        ? this.props.user.result.profileId
        : '';
    this.state.eventId =
      this.props.params &&
      (this.props.params.eventID || this.props.params.eventId)
        ? this.props.params.eventID || this.props.params.eventId
        : '';
    const currentPage =
      this.props.Router &&
      this.props.Router.location &&
      this.props.Router.location.pathname
        ? this.props.Router.location.pathname
        : '';
    if (
      this.profileId &&
      this.state.eventId &&
      this.headerType &&
      this.headerType === GR_HEADER_TYPE.LOGO_MENU &&
      currentPage &&
      currentPage !== this.lastPath
    ) {
      this.lastPath = currentPage;
      // this.getNotificationFlag = false;
      const { loadNotificationsDetail } = this.props;
      loadNotificationsDetail(this.state.eventId, this.profileId);
      const { countNotification } = this.props;
      countNotification(this.state.eventId, this.profileId, this.isClicked);
    }
    const isUserLoggedIn = !!(
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.emailId
    );
    const email = isUserLoggedIn ? this.props.user.result.emailId : '';
    const userName = isUserLoggedIn ? this.props.user.result.firstName : '';
    //

    let count = 0;
    if (this.props.countDataNotifications) {
      count = this.props.countDataNotifications.notificationCount || 0;
    }
    const routeProps = this.props.params;
    const eventManagmentRoutProps = routeProps;
    if (!eventManagmentRoutProps.pageName) {
      eventManagmentRoutProps.pageName = 'DatosDeMiEvento';
    }
    this.eventToken =
      this.props.eventDetails &&
      this.props.eventDetails.tokenForEvent &&
      this.props.eventDetails.tokenForEvent.eventTokeninfo &&
      this.props.eventDetails.tokenForEvent.eventTokeninfo.tokenId
        ? this.props.eventDetails.tokenForEvent.eventTokeninfo.tokenId
        : null;
    // <div className="col-xs-3 text-right closeOptionModal" onClick={this.closeTrackModal} />

    const validateDateForTools = validateEventDate(
      this.props.eventDetails,
      this.state.eventId,
    );

    const modalHeaderForNotification = (
      <div className='row'>
        <div className='col-xs-4 title'>Notificaciones</div>
        <div className='col-xs-8 cerrar text-right'>
          <a id='closeModal' className='closeMenuNotifications'>
            <span className='iclassName icon-cerrar' />
          </a>
        </div>
      </div>
    );

    if (this.state.eventId) {
      // this.props.fetchEventManagementTools(this.state.eventId).then((res) => {
      //   if (res) {
      //     this.getEventToolsData = res;
      //   }
      // });
    }

    if (this.getEventToolsData && this.getEventToolsData.toolsInfo) {
      validateDateForTools &&
      !this.getEventToolsData.useGuestList &&
      !this.getEventToolsData.useTableOrganizer
        ? this.getEventToolsData.toolsInfo.toolsNotInUse[2].toolName ===
          'VirtualInvitation'
          ? (this.wapTools = {
              label: 'Invitación virtual',
              reference: 'virtualInvitation',
            })
          : (this.wapTools = {
              label: 'Invitación virtual',
              reference: 'myInvitation',
            })
        : (this.wapTools = {
            label: 'Herramientas para mi evento',
            reference: 'toolsPage',
          });
    }

    return (
      <React.Fragment>
        <div className='giftMenuMobile container'>
          <div className='row'>
            <div className='col-xs-1 toggle-icon'>
              <i
                className='icon-menu_mobile'
                onClick={() => {
                  this.toggleHamburgerMenu('.giftMenuMobile .menu', count);
                }}
              />
              {count > 0 ? (
                <span
                  className='activeNotificationMenu'
                  id='activeNotificationMenu'
                />
              ) : null}
            </div>
            <div className='col-xs-10 toggle-icon text-center'>
              <img
                onClick={this.dispatchThenRoute}
                className='mainLogo'
                src={mesa_de_regalos_logo}
                alt='Mesa de Regalos'
              />
            </div>
            <div className='col-xs-1' />
            <div
              className='col-xs-12 menu hamburger-menu'
              style={{ display: 'none' }}
            >
              <ul>
                {isUserLoggedIn && (
                  <li>
                    <a>
                      <b>HOLA {userName.toUpperCase()}</b>
                    </a>
                  </li>
                )}
                {/* <li className="notificationItem" onClick={() => { this.handleLinkClickInWAP('notificationPage', routeProps, false); }}> */}
                <li
                  className='notificationItem'
                  onClick={() => {
                    this.openNotification('.giftMenuMobile .hamburger-menu');
                  }}
                >
                  <a>
                    <img
                      className='notificationLogo'
                      src={
                        commonUtil.getAssetURL() +
                        '/images/admin/notificationIcon.png'
                      }
                      alt='Notificationes'
                    />
                    <span>Notificaciones</span>
                    {count > 0 ? (
                      <span className='notificationCount'>
                        {' '}
                        <font>{count}</font>
                      </span>
                    ) : null}{' '}
                    <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
                <li
                  onClick={() => {
                    this.handleLinkClickInWAP('adminPage', routeProps, false);
                  }}
                >
                  <a>
                    Administración de regalos{' '}
                    <i className='icon-flecha_lightsvg_derecha' />
                  </a>{' '}
                </li>
                <li
                  className={
                    this.eventToken && this.eventToken !== null
                      ? ''
                      : 'activeURL'
                  }
                >
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href={
                      this.eventToken && this.eventToken !== null
                        ? serverClientUtil.getEventWebSiteURL() +
                          '?eventId=' +
                          this.state.eventId +
                          '&token=' +
                          this.eventToken
                        : ''
                    }
                  >
                    Página web de mi evento{' '}
                    <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
                {validateDateForTools && this.wapTools && (
                  <li
                    onClick={() => {
                      this.handleLinkClickInWAP(
                        this.wapTools.reference,
                        routeProps,
                        false,
                      );
                    }}
                  >
                    <a>
                      {this.wapTools.label}{' '}
                      <i className='icon-flecha_lightsvg_derecha' />
                    </a>
                  </li>
                )}
                <li
                  onClick={() => {
                    this.handleLinkClickInWAP(
                      'searchEventPage',
                      routeProps,
                      false,
                    );
                  }}
                >
                  <a aria-label='Busqueda'>
                    Buscar una mesa{' '}
                    <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
                <li
                  onClick={() => {
                    this.handleLinkClickInWAP(
                      'createEventPage',
                      routeProps,
                      false,
                    );
                  }}
                >
                  <a>
                    Crear nueva mesa{' '}
                    <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
                <li
                  onClick={() => {
                    this.handleUserLogout(
                      email,
                      '.giftMenuMobile .hamburger-menu',
                    );
                  }}
                >
                  <a>
                    Cerrar Sesión <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
                <li>
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href='//assets.liverpool.com.mx/ayuda/#/sec/mesa-de-regalos/'
                  >
                    <span className='icon-ayuda helpIconHemburger' />
                    Ayuda <i className='icon-flecha_lightsvg_derecha' />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* <ConfirmationModal ref={modal => this.modal = modal} /> */}
        </div>
        <ModalPopover
          modalId='notificationModal'
          ref={(notiModal) => (this.notiModal = notiModal)}
          isModal='true'
          dismiss='false'
          headerData={modalHeaderForNotification}
        >
          <Notifications
            notifications={this.props.notifications || null}
            eventId={this.state.eventId}
            profileId={this.profileId}
            openNotificationBar={this.openNotificationBar}
          />
        </ModalPopover>
      </React.Fragment>
    );
  };

  renderEventManagementMenuForWap = (
    eventManagmentMenu,
    OPENING_GIFT,
    CLOSING_GIFT,
    eventType,
    eventCategories,
  ) => {
    if (eventManagmentMenu && !commonUtil.isEmpty(eventManagmentMenu)) {
      this.eventManagementMenus = eventManagmentMenu;
      this.OPENING_GIFT = OPENING_GIFT;
      this.CLOSING_GIFT = CLOSING_GIFT;
      this.eventType = eventType;
      this.eventCategory = eventCategories;

      const eventManagementMenu1 = [];
      this.eventManagementMenuHTML = [];
      if (this.isEventManagementRoute) {
        Object.keys(eventManagmentMenu.eventData).forEach(
          (eventManagementPage) => {
            let eventDataURL = '';
            if (
              (this.eventCategory === eventCategory.OPENEVENT &&
                eventManagementPage !== this.OPENING_GIFT) ||
              (this.eventCategory !== eventCategory.OPENEVENT &&
                eventManagementPage !== this.CLOSING_GIFT)
            ) {
              if (eventManagementPage) {
                eventDataURL = commonUtil.getRouteByParameter(
                  applicationRoutes.eventManagement,
                  {
                    pageName: eventManagementPage,
                    eventID: this.state.eventId,
                  },
                );
              }
              this.eventManagementRoutes.push(eventDataURL);
              eventManagementMenu1.push(
                <li
                  onClick={() => {
                    this.handleLinkClickInWAP(
                      eventManagmentMenu.eventData[eventManagementPage]
                        .displayName,
                      eventDataURL,
                      true,
                    );
                  }}
                >
                  <a>
                    {' '}
                    {
                      eventManagmentMenu.eventData[eventManagementPage]
                        .displayName
                    }
                    <i className='icon-flecha_lightsvg_derecha' />{' '}
                  </a>
                </li>,
              );
            }
            return null;
          },
        );
        if (eventManagementMenu1 && eventManagementMenu1.length > 0) {
          // Note: check with neha dhakad
          // this.eventManagementMenuHTML.push(<li><a href="javascript:void(0)">Gestión de eventos
          //   <i className="icon-flecha_lightsvg_derecha" /></a>
          // </li>);
          this.eventManagementMenuHTML.push(
            <li>
              <ul>{eventManagementMenu1}</ul>
            </li>,
          );
        }
      }
    }
    this.setState({ updated: true });
  };
  getEventToken = (eventtId) => {
    this.state.eventId = eventtId;
    const { getEventToken } = this.props;
    getEventToken(this.state.eventId);
  };
  handleUserLogout(email, clsName) {
    this.toggleHamburgerMenu(clsName);
    const userLogout = {};
    userLogout.login = email;
    const { handleUserLogout } = this.props;
    handleUserLogout(userLogout).then((response) => {
      if (response.status.status === 'success') {
        if (window) {
          window.location.href = '/';
        }
      }
    });
  }
  toggleHamburgerMenu = (id) => {
    const notificationContainer = document.querySelector(id);
    const bodyContainer = document.getElementsByTagName('body')[0];
    const hamburgerMenu = document.querySelector('.hamburger-menu');
    const backgroundView = document.querySelector('.mobileView');
    const footerView = document.querySelector('.footer');
    if (
      notificationContainer &&
      notificationContainer.style.display === 'none'
    ) {
      const changeMenu = document.querySelector('.icon-menu_mobile');
      changeMenu.className = 'icon-tache2';
      notificationContainer.style.display = 'block';
      bodyContainer.style.overflow = 'hidden';
      backgroundView.style.height = 0;
      footerView.style.height = 0;
      footerView.style.overflow = 'hidden';
      backgroundView.style.overflow = 'hidden';
      // document.querySelector('.hamburger-menu.homePageHemburger').style.marginTop = '-46px';
      hamburgerMenu.style.overflow = 'auto';
      hamburgerMenu.style.height = 'auto';
    } else if (
      notificationContainer &&
      notificationContainer.style.display === 'block'
    ) {
      const changeMenu = document.querySelector('.icon-tache2');
      changeMenu.className = 'icon-menu_mobile';
      notificationContainer.style.display = 'none';
      bodyContainer.style.overflow = 'auto';
      backgroundView.style.height = 'auto';
      footerView.style.height = 'auto';
      footerView.style.overflow = 'auto';
      backgroundView.style.overflow = 'auto';
      hamburgerMenu.style.overflow = '';
      hamburgerMenu.style.height = '';
    }
    if (
      document.querySelector('#homeMainHemburger') &&
      document.querySelector('#homeMainHemburger').style &&
      document.querySelector('#homeMainHemburger').style.left < 0 + 'px'
    ) {
      document.querySelector('#homeMainHemburger').style.left = 0 + 'px';
      document.querySelector('#typeOfEventMenuHemburger').style.left = '100vw'; // window.innerWidth + 'px';
    }
  };
  redirectToLoginPage = (clsName) => {
    this.toggleHamburgerMenu(clsName);
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = window.location.origin;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`,
    );
  };
  addFunctionToHomeHemburgerURL = () => {
    const email =
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.emailId
        ? this.props.user.result.emailId
        : '';
    const isUserLoggedIn = !!(
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.emailId
    );
    const userName = isUserLoggedIn ? this.props.user.result.firstName : '';
    const loginOption = document.querySelector('#loginUser');
    const logoutOption = document.querySelector('#logoutUser');
    const showTypeOfEventMenuContent = document.querySelector(
      '#showTypeOfEventMenu',
    );
    const afterSubMenu = document.querySelector('#typeOfEventMenuHemburger');
    if (showTypeOfEventMenuContent) {
      showTypeOfEventMenuContent.addEventListener('click', () => {
        document.querySelector('#homeMainHemburger').style.left =
          -window.innerWidth + 'px';
        afterSubMenu.style.left = 0 + 'px';
      });
    }
    if (loginOption) {
      loginOption.addEventListener('click', () => {
        this.redirectToLoginPage('.giftMenuMobile .hamburger-menu');
      });
    }
    if (logoutOption) {
      logoutOption.addEventListener('click', () => {
        this.handleUserLogout(email, '.giftMenuMobile .hamburger-menu');
      });
    }
    if (isUserLoggedIn && userName && document.querySelector('#userName')) {
      document.querySelector('#userName').innerText = userName;
    }
  };
  componentDidUpdate() {
    this.addFunctionToHomeHemburgerURL();
  }
  renderHeaderWithLogoAndMenuForHomePage = (
    menuLinkDataForLoggedInUser,
    menuLinkDataForLoggedOutUser,
  ) => {
    let menuLinkDataForLoggedInUserContent = '';
    let menuLinkDataForLoggedOutUserContent = '';
    if (menuLinkDataForLoggedInUser && menuLinkDataForLoggedInUser.length) {
      menuLinkDataForLoggedInUserContent =
        menuLinkDataForLoggedInUser[0] && menuLinkDataForLoggedInUser[0].data
          ? menuLinkDataForLoggedInUser[0].data
          : null;
    }
    if (menuLinkDataForLoggedOutUser && menuLinkDataForLoggedOutUser.length) {
      menuLinkDataForLoggedOutUserContent =
        menuLinkDataForLoggedOutUser[0] && menuLinkDataForLoggedOutUser[0].data
          ? menuLinkDataForLoggedOutUser[0].data
          : null;
    }
    const isUserLoggedIn = !!(
      this.props.user &&
      this.props.user.result &&
      this.props.user.result.emailId
    );
    return (
      <React.Fragment>
        <div className='container'>
          <div className='giftMenuMobile GRHomePageHeader'>
            <div className='row'>
              <div className='col-xs-1 toggle-icon'>
                <i
                  className='icon-menu_mobile'
                  onClick={() => {
                    this.toggleHamburgerMenu('.giftMenuMobile .hamburger-menu');
                  }}
                />
              </div>
              <div className='col-xs-10 toggle-icon text-center'>
                <img
                  className='mainLogo'
                  onClick={this.dispatchThenRoute}
                  src={mesa_de_regalos_logo}
                  alt='Mesa de Regalos'
                />
              </div>
              <div className='col-xs-1' />
            </div>
          </div>
        </div>
        <div className='giftMenuMobile'>
          {isUserLoggedIn ? (
            <div
              className='col-xs-12 hamburger-menu homePageHemburger'
              style={{ display: 'none' }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: menuLinkDataForLoggedInUserContent,
              }}
            />
          ) : (
            <div
              className='col-xs-12 hamburger-menu homePageHemburger'
              style={{ display: 'none', zIndex: 0 }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: menuLinkDataForLoggedOutUserContent,
              }}
            />
          )}
        </div>
      </React.Fragment>
    );
  };

  closeTrackModal = () => {
    this.notiModal.handleHide();
  };
  handleLinkClickInWAP = (val, routeProps, isManagementFlow) => {
    const currentPath =
      this.props && this.props.location && this.props.location.pathname
        ? this.props.location.pathname
        : null;
    if (isManagementFlow) {
      browserHistory.push(routeProps);
    } else {
      const routeArry = [
        {
          pageName: 'virtualInvitation',
          path: commonUtil.getRouteByParameter(
            applicationRoutes.invitationTemplate,
            { eventID: this.state.eventId },
          ),
        },
        {
          pageName: 'myInvitation',
          path: commonUtil.getRouteByParameter(applicationRoutes.myInvitation, {
            eventID: this.state.eventId,
          }),
        },
        {
          pageName: 'notificationPage',
          path: commonUtil.getRouteByParameter(
            applicationRoutes.notificationDetails,
            { eventID: this.state.eventId, profileId: this.profileId },
          ),
        },
        {
          pageName: 'adminPage',
          path: commonUtil.getRouteByParameter(
            applicationRoutes.giftList,
            routeProps,
          ),
        },
        {
          pageName: 'toolsPage',
          path: commonUtil.getRouteByParameter(
            applicationRoutes.toolsForMyEvent,
            routeProps,
          ),
        },
        {
          pageName: 'searchEventPage',
          path: commonUtil.getRouteByParameter(
            applicationRoutes.searchEvent,
            routeProps,
          ),
        },
        {
          pageName: 'createEventPage',
          path: '',
          callBackFuntion: this.checkEventEligibleToCreate,
        },
      ];
      routeArry.map((info) => {
        if (
          info.path &&
          info.path !== currentPath &&
          info.pageName &&
          val === info.pageName
        ) {
          return browserHistory.push(info.path);
        } else if (
          info.callBackFuntion &&
          info.path !== currentPath &&
          info.pageName &&
          val === info.pageName
        ) {
          info.callBackFuntion();
        }
        return null;
      });
    }
    this.toggleHamburgerMenu('.giftMenuMobile .menu');
  };

  renderHeaderWithLogoAndMenu = () => (
    <React.Fragment>
      {channel === 'web'
        ? this.renderHeaderWithLogoAndMenuForWeb() // Header with notification and links.
        : this.renderHeaderWithLogoAndMenuForWap()}
    </React.Fragment>
  );

  renderComponent = () => {
    if (this.headerType === GR_HEADER_TYPE.LOGO_STEP_BAR) {
      return this.renderHeaderWithLogoAndStepBar();
    } else if (this.headerType === GR_HEADER_TYPE.LOGO_MENU) {
      return this.renderHeaderWithLogoAndMenu();
    } else if (this.headerType === GR_HEADER_TYPE.LOGO_PLUS) {
      return this.renderHeaderWithLogoAndAdditionalData(); // TODO: Need to check header for additional properties
    } else if (
      this.headerType === GR_HEADER_TYPE.LOGO_MENU_HOME &&
      channel === 'wap'
    ) {
      const { loadContent, content } = this.props;
      const menuLinkDataForLoggedInUser =
        content &&
        content.targeterContents &&
        content.targeterContents.filter((target) => {
          const main =
            target.name === 'homePageMenuForLoggedInUser' ? target : null;
          return main;
        });
      const menuLinkDataForLoggedOutUser =
        content &&
        content.targeterContents &&
        content.targeterContents.filter((target) => {
          const main =
            target.name === 'homePageMenuForLoggedOutUser' ? target : null;
          return main;
        });
      if (!menuLinkDataForLoggedInUser && !menuLinkDataForLoggedOutUser) {
        loadContent();
      }
      return this.renderHeaderWithLogoAndMenuForHomePage(
        menuLinkDataForLoggedInUser,
        menuLinkDataForLoggedOutUser,
      );
    } else if (this.headerType === GR_HEADER_TYPE.LOGO_ONLY) {
      return this.renderHeaderWithLogo();
    }
    return null;
  };
  setHeaderType = () => {
    if (this.props && this.props.router) {
      this.isEventManagementRoute = false;
      let currentURL = '';
      // let isDynamicRoute = false;
      // let currentPage = '';
      if (this.props.params && !commonUtil.isEmpty(this.props.params)) {
        // currentPage = this.props.params.pageName;
        // isDynamicRoute = true;
        const paramArray = Object.keys(this.props.params);
        const urlParts = this.props.router.location.pathname.split('/');
        const dynamicUrlArray = [];
        let dynamicUrl = '/';
        const urlPartCnt = urlParts.length - paramArray.length;
        let iCnt = 0;
        while (iCnt < urlPartCnt) {
          if (urlParts[iCnt] && urlParts[iCnt].trim().length > 0) {
            dynamicUrlArray.push(urlParts[iCnt]);
          }
          iCnt += 1;
        }
        dynamicUrl += dynamicUrlArray.join(dynamicUrl);
        if (paramArray && paramArray.length > 0) {
          iCnt = 0;
          dynamicUrl += '(';
          while (iCnt < paramArray.length) {
            dynamicUrl += '/:' + paramArray[iCnt];
            iCnt += 1;
          }
          dynamicUrl += ')';
        }
        currentURL = dynamicUrl;
      } else {
        currentURL = this.props.router.location.pathname;
      }
      if (currentURL === applicationRoutes.eventManagement) {
        this.isEventManagementRoute = true;
      }
      Object.keys(grHeaderConfig).forEach((routeConfig) => {
        if (routeConfig === currentURL) {
          this.headerType = grHeaderConfig[routeConfig][channel];
        }
      });
    }
  };

  render() {
    this.setHeaderType();
    return <React.Fragment>{this.renderComponent()}</React.Fragment>;
  }
}

const mapStateToProps = (state) => ({
  data: state.data,
});

const matchDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(GRHeader);
